import {TextInput} from '#component/base';
import {QuestionControls, QuestionText} from '#component/partial/Wizard/component';
import {useSurveyVar} from '#component/partial/Wizard/useSurveyVar';
import {sprinkles} from '#style/sprinkles';

import {NumberQuestionProps} from './NumberQuestion.types';

export const NumberQuestion = ({onBack, onNext, question, surveyId}: NumberQuestionProps) => {
  const {currentValue, onChange} = useSurveyVar({surveyId, question});
  const disabledNext = `${currentValue}`.trim().length < 1;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!disabledNext) {
      onNext?.();
    }
  };

  return (
    <form
      className={sprinkles({flex: 'flex', dir: 'col', gap: [40, 64, 80]})}
      onSubmit={handleSubmit}>
      <QuestionText text={question.text} description={question.description} />

      <TextInput autoFocus onChange={onChange} value={currentValue} />

      <QuestionControls onBack={onBack} disabledNext={disabledNext} />
    </form>
  );
};
